module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1rZn3"))).then(() => parcelRequire('ljYL6'));